import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { trackPageView } from '@/lib/analytics';
import { OfflineBanner } from '@/components/OfflineBanner';

/** Root layout element: fires a GA4 page_view on every route change so we can
 * see which in-app sections caregivers explore. Renders the matched route via
 * <Outlet/>; wraps all routes so signed-out pages (signup/login) are tracked
 * too. No-ops off prod / pre-consent (see lib/analytics.ts). */
export function RouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
  return (
    <>
      <OfflineBanner />
      <Outlet />
    </>
  );
}
